import { fetchProductBySku } from "./fetchProductBySku.js";
export const getBookProduct = async ({ sku }, { client }) => {
    const product = await fetchProductBySku(sku, { client });
    if (!product)
        return;
    return {
        sku,
        name: product.name,
        path: product.path,
        variants: product.variants,
        price: {
            value: product.price ?? 0,
            currency: "NOK",
            type: "single",
        },
    };
};
